import { previewTypes } from 'shared/constants/preview-types';

export function hasTrailer(video) {
  return Boolean(video.trailerFileName);
}

export function isPreviewEnabled(video) {
  return video.previewType !== previewTypes.NONE;
}

export function getPreviewType(video) {
  return video.previewType || previewTypes.FIRST_20_SEC;
}



// WEBPACK FOOTER //
// ./src/shared/ui-selectors/video/preview.js